import { Card } from '../SimulationState'

export function countPile(cards: Card[], pile: number) {
  return cards.reduce(
    (result, card) => result + (card.pile === pile ? 1 : 0),
    0,
  )
}
